import { __awaiter, __extends, __generator } from "tslib";
import { AsyncOperator } from "./AsyncOperator";
import { Operator } from "./Operator";
var Rule = (function (_super) {
    __extends(Rule, _super);
    function Rule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Rule.prototype.evaluate = function (ctx, evaluation) {
        this.ctx = ctx;
        return evaluation["evaluateRule"](this);
    };
    Rule.of = function (rule) {
        var Klass = (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            class_1.prototype.satisfied = function () {
                return rule(this.ctx);
            };
            return class_1;
        }(Rule));
        return new Klass();
    };
    Rule.true = function () {
        return this.of(function () { return true; });
    };
    Rule.false = function (failure) {
        return this.of(function () { return failure !== null && failure !== void 0 ? failure : "Evaluation failed"; });
    };
    return Rule;
}(Operator));
export { Rule };
var AsyncRule = (function (_super) {
    __extends(AsyncRule, _super);
    function AsyncRule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsyncRule.prototype.evaluate = function (ctx, evaluation) {
        this.ctx = ctx;
        return evaluation["evaluateRuleAsync"](this);
    };
    AsyncRule.of = function (rule) {
        var Klass = (function (_super) {
            __extends(class_2, _super);
            function class_2() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            class_2.prototype.satisfied = function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4, rule(this.ctx)];
                            case 1: return [2, _a.sent()];
                        }
                    });
                });
            };
            return class_2;
        }(AsyncRule));
        return new Klass();
    };
    AsyncRule.true = function () {
        return this.of(function () { return true; });
    };
    AsyncRule.false = function (failure) {
        return this.of(function () { return failure !== null && failure !== void 0 ? failure : "Evaluation failed"; });
    };
    return AsyncRule;
}(AsyncOperator));
export { AsyncRule };
